import React from 'react';
import {Alert,Button} from '@mui/material';
export default class SocialsErrorBoundary extends React.Component<{children:React.ReactNode},{failed:boolean}> {
 state={failed:false};
 static getDerivedStateFromError(){return {failed:true};}
 render(){return this.state.failed ? <Alert severity="error" action={<Button onClick={()=>this.setState({failed:false})}>Try again</Button>}>This Socials section could not be displayed. <a href="?page=content&view=legacy">Open previous Content page</a></Alert> : this.props.children;}
}
